import { FC, ReactNode } from 'react';
import { CoreLinkButton } from '@components/CoreLinkButton';

const BreadcrumbLink: FC<{ children: ReactNode; to: string }> = ({ children, to }) => (
  <CoreLinkButton
    sx={{
      '&:hover': { backgroundColor: 'transparent' },
      color: 'primary.main',
      minWidth: 'fit-content',
      padding: 0,
      typography: 'body1',
      textDecoration: 'underline',
    }}
    to={to}
    variant="text"
  >
    {children}
  </CoreLinkButton>
);

export default BreadcrumbLink;
